import config, { Config, CookieConfig } from '../BaseConfig';

const override: Partial<Config> = {
};

// Export here should mirror parent, so webpack can do his magic with alias
export { Config, CookieConfig };
export default { ...config, ...override };
